export enum AccessoryLineSelection {
  ALL = 'all',
  NONE = 'none',
  INVERT = 'invert',
}
